import { toSentenceCase } from '@utils/toSentenceCase';
import React, { type ReactNode } from 'react';
import Styles from './styles.scss';

interface PillProps {
	label: string | ReactNode;
	onClick: (event?: React.MouseEvent<HTMLButtonElement>) => void;
	customStyles?: string;
	selected: boolean;
	customSelectedStyles?: string;
	showMapView?: boolean;
	isImproveMpPerformanceTier2Enabled?: boolean;
}

const Pill = ({
	label,
	onClick,
	customStyles,
	selected,
	customSelectedStyles,
	showMapView,
	isImproveMpPerformanceTier2Enabled,
}: PillProps) => {
	const pillClasses = `
	${showMapView ? Styles.pillMapContainer : Styles.pillContainer}
	${!showMapView && isImproveMpPerformanceTier2Enabled ? Styles.tier2Perf : ''}
	${customStyles}
	${selected ? customSelectedStyles || Styles.selected : ''}
	`;

	const processedLabel =
		typeof label === 'string' ? toSentenceCase(label) : label;

	return (
		<button type="button" className={pillClasses} onClick={onClick}>
			{processedLabel}
		</button>
	);
};

export default Pill;
